var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "container", staticClass: "pb-5" },
    [
      _vm.smsSent
        ? [
            _c("ConfirmMobilePhone", {
              attrs: { user: _vm.user, "job-profile": _vm.jobProfile },
              on: {
                resend: function($event) {
                  return _vm.save(true)
                },
                change: _vm.changeData,
                finish: function($event) {
                  return _vm.$emit("finish", $event)
                }
              }
            })
          ]
        : _vm.checkData
        ? [
            _c("CheckData", { attrs: { user: _vm.user } }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-3 text-right" },
              [
                _c(
                  "b-form-checkbox",
                  {
                    model: {
                      value: _vm.checkDataOk,
                      callback: function($$v) {
                        _vm.checkDataOk = $$v
                      },
                      expression: "checkDataOk"
                    }
                  },
                  [_vm._v("Die Daten stimmen")]
                )
              ],
              1
            )
          ]
        : [
            _c("h3", [
              _vm._v(
                "Geheimhaltung und Datenschutz für dich und Jobsuchende hat Vorrang!"
              )
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("Bitte um Bestätigung:")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-4" },
              [
                _c(
                  "FormGroup",
                  {
                    attrs: {
                      state: _vm.user.secrecyPersonalData === true,
                      "invalid-feedback": "Bitte ankreuzen",
                      "feedback-beneath": ""
                    }
                  },
                  [
                    _c(
                      "b-form-checkbox",
                      {
                        attrs: { disabled: _vm.secrecyValid },
                        on: { input: _vm.secrecyChanged },
                        model: {
                          value: _vm.user.secrecyPersonalData,
                          callback: function($$v) {
                            _vm.$set(_vm.user, "secrecyPersonalData", $$v)
                          },
                          expression: "user.secrecyPersonalData"
                        }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\tIch werde persönlichen Daten, die ich von Personen erhalte (Namen, Geburtsdatum, Mobilnummer,\n\t\t\t\t\tE-Mail Adresse, Arbeitgeber, Adresse usw.) nicht ohne Zustimmung der betroffenen Personen\n\t\t\t\t\tweitergeben oder anderen zugänglich machen.\n\t\t\t\t"
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.secrecyValid
              ? _c(
                  "div",
                  { staticClass: "mt-4" },
                  [
                    _c("h3", [_vm._v("Persönliche Daten")]),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { md: "4" } },
                          [
                            _c(
                              "FormGroup",
                              {
                                attrs: {
                                  state: _vm.userSalutationValid,
                                  "invalid-feedback":
                                    "Bitte triff eine Auswahl",
                                  "feedback-beneath": ""
                                }
                              },
                              [
                                _c("SalutationSelect", {
                                  model: {
                                    value: _vm.user.salutation,
                                    callback: function($$v) {
                                      _vm.$set(_vm.user, "salutation", $$v)
                                    },
                                    expression: "user.salutation"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { staticClass: "mt-2 mt-md-0", attrs: { md: "4" } },
                          [
                            _c(
                              "FormGroup",
                              {
                                attrs: {
                                  state: _vm.userFirstNameValid,
                                  "invalid-feedback":
                                    "Bitte gib deinen Vornamen ein",
                                  "feedback-beneath": ""
                                }
                              },
                              [
                                _c("b-input", {
                                  attrs: { placeholder: "Vorname" },
                                  model: {
                                    value: _vm.user.firstName,
                                    callback: function($$v) {
                                      _vm.$set(_vm.user, "firstName", $$v)
                                    },
                                    expression: "user.firstName"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { staticClass: "mt-2 mt-md-0", attrs: { md: "4" } },
                          [
                            _c(
                              "FormGroup",
                              {
                                attrs: {
                                  state: _vm.userLastNameValid,
                                  "invalid-feedback":
                                    "Bitte gib deinen Nachnamen ein",
                                  "feedback-beneath": ""
                                }
                              },
                              [
                                _c("b-input", {
                                  attrs: { placeholder: "Nachname" },
                                  model: {
                                    value: _vm.user.lastName,
                                    callback: function($$v) {
                                      _vm.$set(_vm.user, "lastName", $$v)
                                    },
                                    expression: "user.lastName"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mt-4" },
                      [
                        _c("h3", [
                          _vm._v(
                            "Mobilnummer - wir senden dir einen Bestätigungscode zu"
                          )
                        ]),
                        _vm._v(" "),
                        _c("Phone", {
                          attrs: { meta: _vm.meta },
                          model: {
                            value: _vm.user.phone,
                            callback: function($$v) {
                              _vm.$set(_vm.user, "phone", $$v)
                            },
                            expression: "user.phone"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._m(1),
                    _vm._v(" "),
                    _vm._m(2)
                  ],
                  1
                )
              : _vm._e()
          ],
      _vm._v(" "),
      !_vm.smsSent
        ? _c(
            "div",
            { staticClass: "mt-4 text-right" },
            [
              _vm.checkData
                ? [
                    !_vm.saving
                      ? _c("Button", {
                          staticClass: "mr-3 mb-3 mb-md-0",
                          attrs: {
                            text: "Daten ändern",
                            secondary: "",
                            icon: "edit"
                          },
                          on: { click: _vm.changeData }
                        })
                      : _vm._e()
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("Button", {
                attrs: {
                  text: _vm.checkData
                    ? "Bestätigen / SMS-Code anfordern"
                    : "Weiter",
                  icon: "checkmark",
                  loading: _vm.saving,
                  disabled: !_vm.dataValid || _vm.saving
                },
                on: {
                  click: function($event) {
                    return _vm.save(false)
                  }
                }
              })
            ],
            2
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "mt-1 font-weight-extra-bold color-primary" },
      [
        _c("span", {}, [_vm._v("Achtung:")]),
        _vm._v(
          " Vor- und Nachname können später nicht mehr geändert werden.\n\t\t\t"
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-4" }, [
      _vm._v(
        "\n\t\t\t\tNur skilldoo erhält deine Daten zur internen Prüfung und gibt sie ohne deine Zustimmung nicht\n\t\t\t\tweiter!"
      ),
      _c("br"),
      _vm._v(
        "\n\t\t\t\tDeine persönlichen Daten werden somit nur für Personen sichtbar, denen du sie später freigibst.\n\t\t\t"
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-4" }, [
      _c("span", { staticClass: "font-weight-extra-bold" }, [
        _vm._v("Kostenfrei:")
      ]),
      _vm._v(
        "\n\t\t\t\tfür die Eintragung des Jobprofils, Suche und Nutzung der grundlegenden Funktionen entstehen keine\n\t\t\t\tKosten und keine Vorauszahlungen.\n\t\t\t\t"
      ),
      _c("br"),
      _vm._v(" "),
      _c("span", { staticClass: "font-weight-extra-bold" }, [_vm._v("Kosten")]),
      _vm._v(
        " entstehen erst, wenn du bestimmte\n\t\t\t\tZusatzfunktionen nützen willst oder Kontaktanfragen senden oder entgegennehmen willst. Bei der\n\t\t\t\tNutzung wirst du gesondert darauf hingewiesen, bevor Kosten entstehen.\n\t\t\t"
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }